import { ProfileModel } from '@vp/profile/core/model/ProfileModel';

export abstract class ProfileManagerRepository {
  abstract getProfiles(controller?: AbortController): Promise<ProfileModel[]>;
}
